



































































































































































































































import PageBody from "@/components/PageBody.vue";
import PageHeader from "@/components/PageHeader.vue";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { NotificationHttp } from "@/mixins/http/notification";
// eslint-disable-next-line no-unused-vars
import dayjs from "dayjs";
// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
// eslint-disable-next-line no-unused-vars
import { NotificationGroup } from "@/types/notification";
import DateUtils from "@/utils/dayjs";
import ConfirmDeleteDialog from "@/components/ConfirmDeleteDialog.vue";

@Component({
	components: {
		"page-header": PageHeader,
		"page-body": PageBody,
		"confirm-delete-dialog": ConfirmDeleteDialog,
	},
})
export default class NotificationGroupsList extends Mixins(NotificationHttp, DateUtils) {
	groups: Array<NotificationGroup> = [];
	filteredGroups: Array<NotificationGroup> = [];
	loading: boolean = false;
	domainEmphasized: string = " ";
	selectedTableColumns: Array<string> = [];
	mounted() {
		this.selectedTableColumns = this.getSelectedColumnsFromLocalStorage();
		this.getGroupsFromApi();
	}

	public deleteGroupFromApi(groupToDelete: NotificationGroup) {
		this.deleteGroup(groupToDelete).then(() => {
			this.getGroupsFromApi();
		});
	}

	getSelectedColumnsFromLocalStorage(): Array<string> {
		if (localStorage.getItem("groupsTableColumns")) {
			return localStorage.getItem("groupsTableColumns")!.split(",");
		} else {
			let defaults = [
				"Recipient",
				"Last Notified",
				"Created",
				"Domains Tracking",
				"Events Tracking",
				"Actions",
			];
			localStorage.setItem("groupsTableColumns", defaults.toString());

			return defaults;
		}
	}

	getGroupsFromApi(): void {
		this.loading = true;
		this.getGroups()
			.then((response: AxiosResponse<any>) => {
				this.groups = response.data;
				this.filteredGroups = this.groups;
			})
			.finally(() => (this.loading = false));

		if (this.$route.query["emphasize"]) {
			this.domainEmphasized = this.$route.query["emphasize"].toString();
		}
	}

	get pageSubtitle(): string {
		let maxNotificationGroups: number = this.$store.getters["account/currentUser"].limits
			.maxNotificationGroups;
		let usedSoFar: number = this.groups.length;
		let leftOver: number = maxNotificationGroups - usedSoFar;
		return leftOver + " of " + maxNotificationGroups + " left";
	}

	get maxNotificationGroupsReached(): boolean {
		return (
			this.groups.length >= this.$store.getters["account/currentUser"].limits.maxNotificationGroups
		);
	}

	filterGroups(filterQuery: string): void {
		this.filteredGroups = this.groups.filter((group) => {
			if (group.groupName) {
				return group.groupName!.toUpperCase().includes(filterQuery.toUpperCase());
			} else return false;
		});
	}

	@Watch("selectedTableColumns") tableColumnsChanged(newVal: Array<string>) {
		localStorage.setItem("groupsTableColumns", newVal.toString());
	}
}
